import Structure from '../modules/structure';

$.fn.searchBarScript = function() {

    var jqAllAffectedContainers = this;
   
    jqAllAffectedContainers.each(function() {
        const container = $(this);
        const structure = new Structure('searchBarScript', container, {
            closeBtn: '.close>a',
            openBtn: '.search-icon>a'
        }).structure;

        structure.openBtn.on('click', function(e) {
            e.preventDefault();
            container.addClass('bar-open');
        });

        structure.closeBtn.on('click', function(e) {
            e.preventDefault();
            container.removeClass('bar-open');
        });
       
    });

    return jqAllAffectedContainers;
};

document.addEventListener('DOMContentLoaded', function() {
    $('.search-bar-js').searchBarScript();
});
